import React, { useEffect, useState } from 'react'
import SectionContributions from './SectionContributions'
import { getCycles } from '../../helpers/api'
import Placeholder from '../misc/placeholder'

const Contributions = ({ Contributor }) => {
    const [cycles, setCycles] = useState(null)
    useEffect(() => {
        getCycles()
            .then(data => {
                setCycles(data)
            })
    }, [])
    if (cycles === null) {
        //wait
        return <Placeholder />
    }
    if (cycles && cycles.length === 0) {
        return <p className="alert alert-info">No contributions detected for this profile.</p>
    }
    return (
        <div>
            {cycles.map((cycle, idx) => (
                <React.Fragment key={idx}>
                    <SectionContributions title={cycle.Label} Contributor={Contributor} cycleId={cycle.CycleID} />
                    {idx < cycles.length - 1 ? (<br />) : null}
                </React.Fragment>
            ))}
        </div>
    )
}

export default Contributions